import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { BCol, BRow, BLink } from "bootstrap-vue";
import Heading from "@/components/Common/Heading.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { useNotificationsStore } from "@/stores/notificationsStore";
import { faExternalLinkAlt, faRetweet } from "@fortawesome/free-solid-svg-icons";
import NotificationActions from "@/components/Notifications/NotificationActions.vue";
import { absPath } from "@/utils/redirect";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SharedItemNotification',
    props: {
        notification: null
    },
    setup(__props) {
        const props = __props;
        library.add(faExternalLinkAlt, faRetweet);
        const notificationsStore = useNotificationsStore();
        function capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
        const content = computed(() => props.notification.content);
        const sharedItemType = computed(() => {
            if (content.value.item_type) {
                return capitalizeFirstLetter(content.value.item_type);
            }
            else {
                return "Item";
            }
        });
        const notificationVariant = computed(() => {
            switch (props.notification.variant) {
                case "urgent":
                    return "danger";
                default:
                    return props.notification.variant;
            }
        });
        const sharedItemUrl = computed(() => {
            return absPath(content.value.slug);
        });
        function markNotificationAsSeen() {
            notificationsStore.updateNotification(props.notification, { seen: true });
        }
        return { __sfc: true, props, notificationsStore, capitalizeFirstLetter, content, sharedItemType, notificationVariant, sharedItemUrl, markNotificationAsSeen, BCol, BRow, BLink, Heading, FontAwesomeIcon, NotificationActions };
    }
});
